'use client';

import React from 'react';

import Error from './error';

interface IProps {
  error: Error;
}

export default function GlobalError({ error }: IProps) {
  return (
    <html>
      <body>
        <Error error={error} />
      </body>
    </html>
  );
}
